import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
const phases = [{
  day: 'Día 1',
  title: 'El Gran Silencio',
  description: 'Un reseteo total de entrada de estímulos para "vaciar el vaso".'
}, {
  day: 'Día 2-4',
  title: 'La Reconfiguración',
  description: 'Introduces dopamina de esfuerzo mediante micro-logros biológicos.'
}, {
  day: 'Día 5-7',
  title: 'El Brillo de Nuevo',
  description: 'Sincronizas tu nueva claridad mental con tus objetivos a largo plazo.'
}];
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark px-4 py-16 md:py-24" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-77">
          <h2 className="font-bebas text-4xl md:text-6xl text-white leading-tight" data-id="element-78">
            CÓMO FUNCIONA
          </h2>

          <div className="space-y-8" data-id="element-79">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="relative pl-12 pb-8 border-l-2 border-teal/30 last:border-l-0 last:pb-0" data-id="element-80">
                <div className="absolute left-0 top-0 -translate-x-1/2 w-8 h-8 bg-teal rounded-full flex items-center justify-center" data-id="element-81">
                  <span className="font-inter font-bold text-sm text-dark" data-id="element-82">
                    {index + 1}
                  </span>
                </div>

                <div className="space-y-2" data-id="element-83">
                  <p className="font-inter text-sm font-semibold text-teal uppercase tracking-wide" data-id="element-84">
                    {phase.day}
                  </p>
                  <h3 className="font-bebas text-2xl md:text-3xl text-white" data-id="element-85">
                    {phase.title}
                  </h3>
                  <p className="font-inter text-base text-text/80 leading-relaxed" data-id="element-86">
                    {phase.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}